class Food2PackInquiry extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.kind = this.querySelector('[data-inquiry-kind]');
    this.fields = this.querySelector('[data-inquiry-fields]');
    this.product = this.querySelector('[data-inquiry-product]');
    this.quantity = this.querySelector('[data-inquiry-quantity]');
    this.reference = this.querySelector('[data-inquiry-reference]');
    if (!this.kind || !this.fields || !this.product || !this.quantity || !this.reference) return;

    this.initialized = true;
    const parameters = new URLSearchParams(window.location.search);
    const requestedKind = parameters.get('aanvraag');
    if (['product', 'offerte'].includes(requestedKind)) this.kind.value = requestedKind;
    if (!this.product.value && parameters.has('product')) {
      this.product.value = parameters.get('product').trim().slice(0, 250);
    }

    const productUrl = parameters.get('product_url');
    if (productUrl) {
      try {
        const referenceUrl = new URL(productUrl, window.location.origin);
        if (referenceUrl.origin === window.location.origin && referenceUrl.pathname.startsWith('/products/')) {
          this.reference.value = `${window.location.origin}${referenceUrl.pathname}${referenceUrl.search}`;
        }
      } catch {
        this.reference.value = '';
      }
    }

    this.onKindChange = this.updateFields.bind(this);
    this.kind.addEventListener('change', this.onKindChange);
    this.updateFields();
  }

  disconnectedCallback() {
    this.kind?.removeEventListener('change', this.onKindChange);
    this.initialized = false;
  }

  updateFields() {
    const isRequest = ['product', 'offerte'].includes(this.kind.value);
    const isQuote = this.kind.value === 'offerte';
    this.fields.hidden = !isRequest;
    this.fields.disabled = !isRequest;
    this.product.required = isRequest;
    this.quantity.required = isQuote;
    this.querySelectorAll('[data-product-required]').forEach(element => { element.hidden = !isRequest; });
    this.querySelectorAll('[data-quantity-required]').forEach(element => { element.hidden = !isQuote; });
  }
}

if (!customElements.get('food2pack-inquiry')) {
  customElements.define('food2pack-inquiry', Food2PackInquiry);
}